import { clearFilterParams, useCleanFilterForRequest, useFilterState } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft } from 'ramda'
import React from 'react'

import { getQueryParam } from '../../../../packages/kiti/utils/helpers/url'
import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import LazyAction from '../../../../packages/kiti/components/helpers/LazyAction'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'
import { convertFilterToRelativeDates } from '../../../../utils/helpers/date'

const Context = React.createContext()
const { Provider } = Context
export const useServiceOrdersState = () => React.useContext(Context) || {}
export const useServiceOrders = () => useServiceOrdersState()?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders(
    $page: Int
    $search: String
    $searchType: ServiceOrderSearchType
    $sort: ServiceOrderSort
    $filter: ServiceOrderFilter
  ) {
    serviceOrders(page: $page, search: $search, searchType: $searchType, sort: $sort, filter: $filter, limit: 8) {
      id
      name
      yearlyId
      endDate
      scheduling
      insertedAt
      slaExpiresAt
      priority {
        id
        name
      }
      tagId
      tag {
        id
        name
        color
      }
      status {
        id
        name
        label
        color
      }
      checklist {
        id
        name
      }
      place {
        id
        name
        resume
      }
      asset {
        id
        name
        type {
          id
          name
        }
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, columnFilters, sort, uncontrolledChildren }) => {
  const { search, searchType } = useFilterState()
  let filter = mergeDeepLeft(clearFilterParams(columnFilters || []) || {}, useCleanFilterForRequest() || {})
  filter = convertFilterToRelativeDates(filter)

  const demo = getQueryParam('d')

  const { data, refetch, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page: 1,
      search,
      searchType: !!searchType && !!search ? searchType : undefined,
      filter,
      sort
    },
    flexiblePollInterval: demo === 'true' ? 5000 : 17000,
    client: serviceOrdersClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren} noEmptyMessage>
        {children}
        <LazyAction action={fetchMore} waiting={state.loading || state.isFetchingMore} />
      </StatePresenter>
    </Provider>
  )
}

ServiceOrdersLoader.useList = useServiceOrders

export default ServiceOrdersLoader
